import script from "./AddressResult.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressResult.vue?vue&type=script&setup=true&lang=js"

import "./AddressResult.vue?vue&type=style&index=0&id=1f40a3a4&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f40a3a4"]])

export default __exports__